import fetch from '../utils/fetch';
// import fetch from '../utils/fetch'
import { baseUrl } from '../utils/env';

/**
 * 获取微信openId
 */
export const ajaxWechatInfo = (data) => {
  return fetch(baseUrl + '/api/wechat/getWechatInfo', data, 'POST');
};
/**
 * 绑定
 */
export const ajaxWechatEmail = (data) => {
  return fetch(baseUrl + '/api/wechat/bindWechatEmail', data, 'POST');
};
/**
 * 解绑
 */
export const ajaxUnbindWechat = (data) => {
  return fetch(baseUrl + '/api/wechat/unBindWechatEmail', data, 'POST');
};
/**
 * 设备状态查询
 */
export const ajaxDeviceStatus = (data) => {
  return fetch(baseUrl + '/api/wechat/getDeviceStatus', data, 'POST');
};
// /**
//  * 获取图片验证码
//  */
// export const ajaxImageCode = () => {
//   return fetch(baseUrl + '/api/web/captcha/get/');
// };
/**
 * 获取用户电话（根据邮箱
 */
export const ajaxWechatTelFromEmail = (data) => {
  return fetch(baseUrl + '/api/wechat/getWechatTelFromEmail', data, 'POST');
};
/**
 * 获取BP余额
 */
export const ajaxWechatBalance = (data) => {
  return fetch(baseUrl + '/api/wechat/getWechatBalance', data, 'POST');
};
/**
 * 获取 discount\RMBPrice\minAmount\maxAmount等信息
 */
export const ajaxWechatSevenDayPrice = (data) => {
  return fetch(baseUrl + '/api/wechat/getWechatSevenDayPrice', data, 'POST');
};
/**
 * 微信发起提现
 */
export const ajaxWechatCommitBuyBack = (data) => {
  return fetch(baseUrl + '/api/wechat/setWechatCommitBuyBack', data, 'POST');
};
/**
 * 微信获取JD卡兑换面额张数等信息
 */
export const ajaxWechatExchangeInfo = (data) => {
  return fetch(baseUrl + '/api/wechat/getWechatExchangeInfo', data, 'POST');
};
/**
 * 发起JD卡兑换
 */
export const ajaxWechatCommitExchange = (data) => {
  return fetch(baseUrl + '/api/wechat/setWechatCommitExchange', data, 'POST');
};


export const ajaxWechatAccountUnify = (data) => {
  return fetch(baseUrl + '/api/wechat/setWechatAccountUnify', data, 'GET');
};

